import "./../../../../node_modules/jquery-timepicker/jquery.timepicker.js";
import "./time-picker.scss";
import "custom-event-polyfill";
import "jquery-timepicker/jquery.timepicker.css";

import { autoinject, bindable, bindingMode, customElement } from "aurelia-framework";

import type { ITimePickerOptions } from "../../../resources-vue/vue-interfaces/i-time-picker";

@autoinject
@customElement("time-picker")
export class TimePicker {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public options: ITimePickerOptions = {
        timeFormat: "hh:mm p",
        interval: 15,
        dynamic: true,
        dropdown: true,
        scrollbar: true
    };
    public $el: JQuery<HTMLElement>;
    private _timePicker: JQuery;
    private _self: HTMLElement;
    private updatedValue: Date = new Date();

    public constructor(element: Element) {
        this._self = element as HTMLElement;
    }

    public attached() {
        this.$el = jQuery(this._self).find("input");
        this.initTimePicker();
    }

    private initTimePicker() {
        if (!this._timePicker && this.$el && this.$el.toArray().length === 1) {
            let timePickerOptions = Object.assign(this.options, {
                change: (newTime: Date) => {
                    if (newTime) {
                        this.updatedValue = newTime;
                        let changeEvent = new CustomEvent("change", {
                            detail: {},
                            bubbles: true
                        });
                        // Target = input(s), input(s) was modified outside of dom events, need to notify the binder.
                        let inputs = jQuery("input", this._self);
                        for (let input of inputs.toArray()) {
                            input.dispatchEvent(changeEvent);
                        }
                        // Anyone listening on the custom element.
                        this._self.dispatchEvent(changeEvent);
                    }
                }
            });
            this._timePicker = (jQuery(this.$el) as any).timepicker(timePickerOptions);
        } else {
            if (!this.$el || this.$el.toArray().length !== 1) {
                console.warn(`The time-picker custom element must contain one child of type input[type=text].
                             When using ranges, the input-group must follow standard bootstrap formats.`);
            }
        }
    }

    public detached() {
        if (this._timePicker) {
            (jQuery(this._timePicker) as any).timepicker("destroy");
            this._timePicker = undefined;
        }
    }
}
